import { render, staticRenderFns } from "./TradeRequestItems.vue?vue&type=template&id=27323398"
import script from "./TradeRequestItems.vue?vue&type=script&lang=js"
export * from "./TradeRequestItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports